import { gql } from "@apollo/client";

const END_MESSENGER_CALL = gql`
  mutation endMessengerCall($callId: String!) {
    endMessengerCall(callId: $callId)
  }
`;

export default END_MESSENGER_CALL;
